/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import CounterText from '../game/CounterText';
import PuzzleLayout from '../game/PuzzleLayout';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import NumberChoiceMenu from '../ui/NumberChoiceMenu';
import NumberDisplay from '../ui/NumberDisplay';
import PuzzleDisplay from '../ui/PuzzleDisplay';
import UIAssetKeys from '../UIAssetKeys';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  init() {
    this.puzzleData = null;
    this.curPuzzleIndex = null;

    /** @type {{ width: number, height: number, answer: number, paths: number[][], numbers: number[] }} */
    this.curPuzzleData = null;

    this.puzzleLayout = null;
    this.puzzleDisplay = null;

    this.hud = null;
    this.btnNextPuzzle = null;
    this.btnCheckAnswer = null;
    this.prizes = ['coins','amulet','vase','cup','knife','idol', 'gem', 'ring', 'bracelet', 'earrings', 'necklace', 'mask', 'crown'];

    /** @type {Phaser.GameObjects.Image[]} */
    this.checkMarks = [];

    // drag fix
    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  create() {
    const backgroundImage = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._open_background, this).setOrigin(0);

    this.chestTop = ABCyaPhaser.Images.addImage(this.scale.width / 2 - 10, this.scale.height / 2 + 140 - 25, UIAssetKeys._chest_top, this);

    this.curPuzzleIndex = 0;
    this.puzzleData = gameData.puzzleData;
    this.puzzleCount = this.puzzleData.puzzles.length;

    this.puzzleLayout = new PuzzleLayout();

    this.puzzleDisplay = new PuzzleDisplay(this);
    this.puzzleDisplay.x = 300;
    this.puzzleDisplay.y = 300;
    this.add.existing(this.puzzleDisplay);

    this.makeButtons();

    this.puzzleNumberDisplay = new CounterText(this, '_VALUE_', 20, Phaser.Display.Color.GetColor(113,62,17));
    this.puzzleNumberDisplay.x = 0;
    this.puzzleNumberDisplay.y = -2;
    this.add.existing(this.puzzleNumberDisplay);
    this.puzzleNumberDisplay.setValue(1);

    this.loadPuzzle();
  }

  checkAnswerClick () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    const answer = this.curPuzzleData.answer;
    const paths = this.curPuzzleData.paths;
    const len = paths.length;
    let total = 0;
    let pathsCorrect = 0;
    let plen = null;
    for (let i = 0; i < len; i++) {
      plen = paths[i].length;
      total = 0;
      for (let j = 0; j < plen; j++) {
        const value = this.puzzleLayout.getValueFromIndex(paths[i][j]);
        if (value >= 0) {
          total += value;
        }
      }
      if (total === answer) {
        pathsCorrect++;
      }
    }

    if (pathsCorrect === paths.length) {
      NumberDisplay.allLightsOn();
      this.openChest();
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._wrong_answer, this);
      this.showBats();
    }
  }

  openChest () {
    // place prize in chest
    this.puzzleNumberDisplay.alpha = 0;
    this.mysticNumber.alpha = 0;

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_tomb, this);

    this.prize?.destroy();

    this.prize = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2 + 165, this.prizes[this.curPuzzleIndex], this).setScale(0.5);
    this.children.moveTo(this.prize, 1);

    this.scroll?.destroy();

    this.scroll = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 35 - 20, this.scale.height / 2 + 10, UIAssetKeys._results_scroll, this);
    this.scroll.alpha = 0;
    this.children.moveTo(this.scroll, 1);
    this.scroll.scale = 0.85;

    ABCyaPhaser.Tweens.addTween(this.chestTop, 1500, { x: this.chestTop.x - 900 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.puzzleImage, 1500, { x: this.puzzleImage.x - 900 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.numberMenu, 1500, { x: this.numberMenu.x - 900 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.prize, 750, { delay: 1000, scale: 2 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.prize, 750, { delay: 1300, y: this.prize.y - 135 }, Phaser.Math.Easing.Linear, () => {
      this.playPrizeSound();
    });

    ABCyaPhaser.Tweens.addTween(this.scroll, 2000, { delay: 2000, alpha: 1 }, Phaser.Math.Easing.Linear);

    this.time.delayedCall(2000, this.placeCheckMarks, null, this);

    // disable buttons
    this.removeButtons();
  }

  playPrizeSound () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._prize_appears, this);
  }

  placeCheckMarks () {
    // place check mark on all spots where level was completed
    const positions = [];

    for (let i = 0; i < 13; i++) {
      let x = 0;
      let y = 0;

      switch (i) {
        case 0:
          x = this.scale.width / 2 - 85 - 0;
          y = this.scale.height / 2 - 55 + 35;
          break;

        case 1:
          x = this.scale.width / 2 + 30 - 20;
          y = this.scale.height / 2 - 73 + 35;
          break;

        case 2:
          x = this.scale.width / 2 + 148 - 40;
          y = this.scale.height / 2 - 98 + 40;
          break;

        case 3:
          x = this.scale.width / 2 + 258 - 57;
          y = this.scale.height / 2 - 108 + 40;
          break;

        case 4:
          x = this.scale.width / 2 + 377 - 73;
          y = this.scale.height / 2 - 122 + 46;
          break;

        case 5:
          x = this.scale.width / 2 - 78;
          y = this.scale.height / 2 + 84;
          break;

        case 6:
          x = this.scale.width / 2 + 19;
          y = this.scale.height / 2 + 71;
          break;

        case 7:
          x = this.scale.width / 2 + 119;
          y = this.scale.height / 2 + 50;
          break;

        case 8:
          x = this.scale.width / 2 + 220;
          y = this.scale.height / 2 + 40;
          break;

        case 9:
          x = this.scale.width / 2 + 318;
          y = this.scale.height / 2 + 34;
          break;

        case 10:
          x = this.scale.width / 2 - 69;
          y = this.scale.height / 2 + 192;
          break;

        case 11:
          x = this.scale.width / 2 + 32;
          y = this.scale.height / 2 + 179;
          break;

        case 12:
          x = this.scale.width / 2 + 128;
          y = this.scale.height / 2 + 162;
          break;
      }

      positions.push([x,y]);
    }

    this.checkMarks = [];
    for (let i = 0; i < gameData.LEVELS_COMPLETED.length; i++) {
      const completed = gameData.LEVELS_COMPLETED[i];
      if (completed && i !== this.curPuzzleIndex) {
        // replace check marks with picture of prize
        const prize = ABCyaPhaser.Images.addImage(0,0,`${this.prizes[i]}_small`, this);

        const pos = positions[i];
        prize.x = pos[0];
        prize.y = pos[1];
        prize.scale = 0.85;
        prize.alpha = 0;
        ABCyaPhaser.Tweens.addTween(prize, 2000, { alpha: 1 }, Phaser.Math.Easing.Linear);

        this.checkMarks.push(prize);
      }
    }

    gameData.LEVELS_COMPLETED[this.curPuzzleIndex] = true;

    this.children.bringToTop(this.prize);

    const pos = positions[this.curPuzzleIndex];

    ABCyaPhaser.Tweens.addTween(this.prize, 1000, { x: pos[0], y: pos[1] }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.prize, 1000, { scale: 0.4 }, Phaser.Math.Easing.Linear, () => {
      if (this.prize) {
        ABCyaPhaser.Tweens.addTween(this.prize, 10, { alpha: 0 }, Phaser.Math.Easing.Linear, () => {
          this.playCheckSound();
          this.placeSmallPrize(pos[0], pos[1]);
        });
      }
    });

    this.nextButton = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._next_button, this).setInteractive();
    this.nextButton.x = this.scale.width - this.nextButton.width - 30;
    this.nextButton.y = this.scale.height / 2 + 145;
    this.nextButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.nextPuzzle, this);
    this.nextButton.scale = 0.80;
    this.nextButton.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.nextButton, 1000, { alpha: 1 }, Phaser.Math.Easing.Linear);
  }

  playCheckSound () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._check, this);
  }

  placeSmallPrize (x, y) {
    const name = `${this.prizes[this.curPuzzleIndex]}_small`;
    const prize = ABCyaPhaser.Images.addImage(x, y, name, this);
    prize.scale = 0.85;

    this.currentCheck = prize;
  }

  nextPuzzle () {
    this.nextButton.destroy();
    this.closeChest();
    this.nextPuzzleClick();
  }

  closeChest () {
    this.puzzleNumberDisplay.alpha = 1;

    this.chestTop.x += 900;
    this.puzzleImage.x += 900;
    this.numberMenu.x += 900;

    this.scroll.destroy();
    this.prize.destroy();
    this.scroll = null;
    this.prize = null;

    for (let i = 0; i < this.checkMarks.length; i++) {
      const check = this.checkMarks[i];
      check.destroy();
    }

    this.checkMarks = [];

    this.currentCheck?.destroy();

    this.makeButtons();
  }

  makeButtons () {
    this.btnCheckAnswer = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._check_answer_button, this).setInteractive();
    this.btnCheckAnswer.x = this.scale.width - this.btnCheckAnswer.width - 70 + 130;
    this.btnCheckAnswer.y = this.scale.height - this.btnCheckAnswer.height * 2 - 30;
    this.btnCheckAnswer.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.checkAnswerClick, this);

    this.btnNextPuzzle = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._skip_puzzle_button, this).setInteractive();
    this.btnNextPuzzle.x = this.scale.width - this.btnNextPuzzle.width - 70 + 130;
    this.btnNextPuzzle.y = this.scale.height - this.btnNextPuzzle.height - 20;
    this.btnNextPuzzle.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.nextPuzzleClick, this);

    this.btnBackPuzzle = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._back_button, this).setInteractive();
    this.btnBackPuzzle.x = this.btnNextPuzzle.width - 70 + 20;
    this.btnBackPuzzle.y = this.scale.height - this.btnNextPuzzle.height - 20;
    this.btnBackPuzzle.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.backPuzzleClick, this);

    if (this.puzzleNumberDisplay) this.puzzleNumberDisplay.alpha = 1;
    if (this.mysticNumber) this.mysticNumber.alpha = 1;
  }

  nextPuzzleClick () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    if (this.curPuzzleIndex < this.puzzleCount - 1) {
      this.curPuzzleIndex++;
    }
    else {
      this.curPuzzleIndex = 0;
    }
    this.loadPuzzle();
  }

  loadPuzzle () {
    if (gameData.INSTRUCTIONS_SHOWN === false) {
      this.showInstructions();
    }

    ABCyaPhaser.Audio.stopSoundByName(this, SoundAssetKeys._number_appears);
    ABCyaPhaser.Audio.stopSoundByName(this, SoundAssetKeys._number_stops);
    this.playNumberStopsDelayedCall?.remove();
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._number_appears, this);

    this.puzzleNumberDisplay.setValue(this.curPuzzleIndex + 1);

    NumberDisplay.instances = [];
    NumberDisplay.allBlinkOff();

    this.puzzleImage?.destroy();

    // load puzzle image where balls need to be dropped
    this.puzzleImage = ABCyaPhaser.Images.addImage(0,0,`puzzle-${this.curPuzzleIndex + 1}`, this);
    this.children.moveTo(this.puzzleImage, 2);
    this.puzzleImage.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.puzzleImage, 2500, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.puzzleImage.x = this.scale.width / 2 - 10;
    if (this.curPuzzleIndex === 10) {
      this.puzzleImage.x = this.scale.width / 2 + 10;
    } if (this.curPuzzleIndex === 12) {
      this.puzzleImage.x = this.scale.width / 2 + 2;
    }
    this.puzzleImage.y = this.scale.height / 2 + 130;

    // load mystic number
    if (this.mysticNumber) this.tweens.killTweensOf(this.mysticNumber);
    this.mysticNumber?.destroy();
    this.mysticNumber = ABCyaPhaser.Images.addImage(0,0,`mystic-${this.curPuzzleIndex + 1}`,this);
    this.mysticNumber.scale = 0;

    this.mysticNumber.x = this.scale.width / 2;
    this.mysticNumber.y = this.scale.height / 2;

    ABCyaPhaser.Tweens.addTween(this.mysticNumber, 1500, { scale: 1 }, Phaser.Math.Easing.Bounce.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.mysticNumber, 1000, { y: this.mysticNumber.y + 290 }, Phaser.Math.Easing.Linear);
    });

    this.playNumberStopsDelayedCall = this.time.delayedCall(1700, this.playNumberStops, null, this);

    // reset this on load Puzzle
    this.curPuzzleData = null;
    this.curPuzzleData = this.puzzleData.puzzles[this.curPuzzleIndex];

    const numbers = this.curPuzzleData.numbers;

    this.numberMenu?.destroy();

    this.numberMenu = new NumberChoiceMenu(this);
    this.add.existing(this.numberMenu);
    this.numberMenu.setMenu(numbers);

    this.puzzleLayout.reset(this.curPuzzleData.width,this.curPuzzleData.height);
    this.puzzleDisplay.displayPuzzle(this.puzzleLayout.spotMatrix, this.curPuzzleData.paths, this.curPuzzleIndex);
  }

  showInstructions () {
    gameData.INSTRUCTIONS_SHOWN = true;

    this.instructions = ABCyaPhaser.Images.addImage(this.scale.width / 2,this.scale.height / 2 + 150, UIAssetKeys._instructions, this).setInteractive();
    this.instructions.alpha = 0;

    this.instructions.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.closeInstructions, this);

    ABCyaPhaser.Tweens.addTween(this.instructions, 2000, { alpha: 1, completeDelay: 3000 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.instructions, 2000, { alpha: 0 }, Phaser.Math.Easing.Linear, () => this.closeInstructions());
    });
  }

  closeInstructions () {
    if (this.instructions === null) { return; }

    this.tweens.killTweensOf(this.instructions);
    this.instructions.destroy();
    this.instructions = null;
  }

  playNumberStops () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._number_stops, this);
    this.playNumberStopsDelayedCall = null;
  }

  /**
   * 
   * @param {NumberDisplay} item 
   */
  checkChoiceDrop (item) {
    let pt = this.puzzleDisplay.getLocalPoint(item.x, item.y);
    const tileCollidedWith = this.puzzleDisplay.checkDropCollision(pt.x, pt.y, item.workingWidth / 2);
    if (tileCollidedWith !== null) {
      pt = ABCyaPhaser.GameObjects.getScreenPosition(tileCollidedWith);

      // check if there's one already there
      const occupied = this.numberMenu.findPlacedItem(tileCollidedWith.indexNum);
      if (occupied !== null && occupied !== item) {
        occupied.x = occupied.menuX;
        occupied.y = occupied.menuY;
        occupied.shadow.setVisible(true);
        occupied.placedIndex = null;

        // turn off item that is replaced
        occupied.blinkOff();
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._woosh, this);
      }
      if (item.placedIndex !== null) {
        // the item was already placed, clear out the previous spot
        this.puzzleLayout.setTileValue(item.placedIndex, -1);
      }
      item.placedIndex = tileCollidedWith.indexNum;
      item.x = pt.x;
      item.y = pt.y;
      this.puzzleLayout.setTileValue(item.placedIndex, item.num);

      // item has hit target
      item.blinkOn();

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._select, this);
    }
    else {
      item.blinkOff();

      item.x = item.menuX;
      item.y = item.menuY;
      item.shadow.setVisible(true);
      if (item.placedIndex !== null) this.puzzleLayout.setTileValue(item.placedIndex, -1);
      item.placedIndex = null;
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._deselect, this);
    }
  }

  backPuzzleClick () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    if (this.curPuzzleIndex > 0) {
      this.curPuzzleIndex--;
    }
    else {
      this.curPuzzleIndex = this.puzzleCount - 1;
    }
    this.loadPuzzle();
  }

  removeButtons () {
    this.btnCheckAnswer.destroy();
    this.btnNextPuzzle.destroy();
    this.btnBackPuzzle.destroy();
  }

  showBats () {
    this.removeButtons();

    // place prize in chest
    this.puzzleNumberDisplay.alpha = 0;
    this.mysticNumber.alpha = 0;

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_tomb, this);

    this.prize?.destroy();

    ABCyaPhaser.Tweens.addTween(this.chestTop, 500, { x: this.chestTop.x - 200 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.puzzleImage, 500, { x: this.puzzleImage.x - 200 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.numberMenu, 500, { x: this.numberMenu.x - 200 }, Phaser.Math.Easing.Linear);

    for (let i = 0; i < 15; i++) {
      const bat = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 200, this.scale.height / 2 + 80, UIAssetKeys._bat, this);
      bat.scale = 0.2;
      bat.alpha = 0;
      const rot = Phaser.Math.Between(0, 45);
      bat.angle = rot;

      const y = Phaser.Math.Between(0, 400) - 600;

      const delay = Phaser.Math.Between(150, 1200);

      ABCyaPhaser.Tweens.addTween(bat, 700, { delay, x: bat.x + 800, y: bat.y + y, scale: 1 }, Phaser.Math.Easing.Linear);
      ABCyaPhaser.Tweens.addTween(bat, 150, { delay, alpha: 1 }, Phaser.Math.Easing.Linear);
    }

    this.time.delayedCall(1600, this.slideTombBack, null, this);
    this.time.delayedCall(1600, this.playSlideTomb, null, this);
  }

  slideTombBack () {
    ABCyaPhaser.Tweens.addTween(this.chestTop, 500, { x: this.chestTop.x + 200 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.puzzleImage, 500, { x: this.puzzleImage.x + 200 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.numberMenu, 500, { x: this.numberMenu.x + 200 }, Phaser.Math.Easing.Linear);

    this.time.delayedCall(700, this.makeButtons,null,this);
  }

  playSlideTomb () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_tomb, this);
  }
}